export default __webpack_public_path__ + "static/media/meat.87171354.jpg";